module.exports = __webpack_public_path__ + "img/certificate-EC-foundation.c69174ba.jpg";